import { initDependencies, setupDependencies } from './app';
require('./index.css');

setupDependencies();

initDependencies();

import('./services/runApp').then(({ runApp }) => runApp());

// tslint:disable-next-line:no-any
if ((module as any).hot) {
  // tslint:disable-next-line:no-any
  (module as any).hot.accept();
}
